import { OrderedCategorizedImage } from "./useCategorizedImageData";
import { PredictionPoint } from "protos/veselka/prediction_point";
import { useMemo } from "react";
import { useNavigateExpandedImage } from "portal/components/images/useNavigateExpandedImage";

interface ExpandedImageState {
  index: number;
  data: PredictionPoint;
  editableCategoryId?: string;
}

interface UseExpandedImageNavigationReturn {
  onNext?: () => void;
  onBack?: () => void;
}

export const useExpandedImageNavigation = (
  orderedCombinedData: OrderedCategorizedImage[],
  expandedImage: ExpandedImageState | undefined,
  setExpandedImage: React.Dispatch<
    React.SetStateAction<ExpandedImageState | undefined>
  >,
  categoryId?: string
): UseExpandedImageNavigationReturn => {
  const onChangeImage = useNavigateExpandedImage<PredictionPoint>(
    orderedCombinedData.map(({ data }) => data),
    setExpandedImage,
    expandedImage
  );

  const onNext = useMemo(() => {
    const next = onChangeImage(1);
    if (!next) {
      return;
    }
    return () => {
      next();
      setExpandedImage((prev) =>
        prev ? { ...prev, editableCategoryId: categoryId } : undefined
      );
    };
  }, [onChangeImage, categoryId, setExpandedImage]);

  const onBack = useMemo(() => {
    const back = onChangeImage(-1);
    if (!back) {
      return;
    }
    return () => {
      back();
      setExpandedImage((prev) =>
        prev ? { ...prev, editableCategoryId: categoryId } : undefined
      );
    };
  }, [onChangeImage, categoryId, setExpandedImage]);

  return { onNext, onBack };
};
